import { Component, OnInit, ViewChild } from "@angular/core";
import { UserApiService } from "../core/api/user-api.service";
import { LangService } from "../core/services/lang.service";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { SpinnerService } from "../core/services/spinner.service";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RouterLink, RouterOutlet } from "@angular/router";


@Component({
  selector: 'app-main-shared-customer-profile',
  standalone: true,
  imports: [
    TranslatePipe,
    RouterLink,
    RouterOutlet,
  ],
  templateUrl: './main-shared-customer-profile.component.html',
  styleUrl: './main-shared-customer-profile.component.scss'
})
export class MainSharedCustomerProfileComponent {
      public currentLang;
      public token: string;
      public isTokenGenerated = false;
      public isMultiple: boolean = false;
      constructor(
          private langService: LangService,
          private userApiService: UserApiService,
          private toastr: ToastrService,
          private spinner: SpinnerService,
          private translateService: TranslateService,
          private activatedRoute: ActivatedRoute,
          private router: Router,
      ) {
          this.currentLang = this.langService.getSavedLang();

          this.token = '';

      }

      ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
          const token = params['token'];
          // this.spinner.hide();
          if (!token) {
            this.translateService.get('customerTasksPage.toastrMsgs.tokenInvalid').subscribe((res: string) => {
              this.toastr.error(res);
            });
            this.router.navigate(['/']);
            return;
          }
          this.isTokenGenerated = true;
          this.userApiService.validateToken(token).subscribe((response) => {
            this.isMultiple = response.multiple === 1;
          });
          this.spinner.hide();

        }
        );
      }

    onSubmit(): void {
    }

    public onLogoClick() {
      if (this.isMultiple) {
        this.router.navigate(['/forwarded'], { queryParams: { token: this.token } });
      } else {
        window.location.href = window.location.href;
      }
    }

      public useLang(value) {
          this.langService.changeLang(value);
          this.userApiService.patchLanguage(value).subscribe();
      }

}
